// Decisiones de la fila compacta del panel de flota (pura, con tests).
//
// La fila tiene un ancho fijo para el "hace cuánto" (~48 px) y no le cabe el
// texto largo de getTimeAgo ("2 horas y 41 min", que en la tarjeta ya sale
// truncado como "2 horas y…"). Wialon resuelve lo mismo con "hace 17 s"; acá
// se abrevia a una sola unidad, que es lo que se lee de reojo en una lista.

export type ListDensity = "compact" | "detailed";

export const DENSITY_STORAGE_KEY = "dumax.lite.listDensity";

// Compacta por omisión: es el motivo de la vista. El 5-oct-2026 la tarjeta
// detallada dejaba ver 2.3 unidades en 761 px; Wialon, ~20.
export const parseDensity = (raw: string | null | undefined): ListDensity =>
  raw === "detailed" ? "detailed" : "compact";

// seconds: epoch del último reporte en SEGUNDOS (VehicleSocket.lastReport._seconds).
// 0 o negativo = nunca reportó.
export const shortAgo = (seconds: number, nowMs: number, nowLabel: string): string => {
  if (!seconds || seconds <= 0) return "—";
  const diff = Math.max(0, Math.floor(nowMs / 1000) - seconds);
  if (diff < 60) return nowLabel;
  const min = Math.floor(diff / 60);
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `${h} h`;
  return `${Math.floor(h / 24)} d`;
};

// Velocidad para la fila: sólo cuando la unidad se mueve. "0 km/h" en cada
// detenida es ruido que el punto de estado ya dice.
export const rowSpeed = (liveSpeed: number | null): string =>
  liveSpeed != null && liveSpeed >= 1 ? `${Math.round(liveSpeed)} km/h` : "";

// Tipo y modelo en una sola línea gris («Vehículo · FMC130»). La comparten la
// tarjeta (#908) y el modal de grupo del mapa: los dos tenían 2-3 chips de
// colores (azul, ámbar, morado) que competían con el estado, que sí es lo urgente.
export const unitKindLine = (
  v: { vehicle_id?: string | null; remolque_id?: string | null; device?: { type?: string } | null },
  label: { vehicle: string; trailer: string; device: string },
): string => {
  const kinds = [v.vehicle_id && label.vehicle, v.remolque_id && label.trailer].filter(Boolean);
  return [...(kinds.length ? kinds : [label.device]), v.device?.type].filter(Boolean).join(" · ");
};
